// extracted by extract-css-chunks-webpack-plugin
module.exports = {"thumbnail":"thumbnail-selector__thumbnail__1br-N","active":"thumbnail-selector__active__1wpfU","disabled":"thumbnail-selector__disabled__3L-nT"};